import React, {Component} from 'react'
import PropTypes from "prop-types"
import {connect} from 'react-redux'
import Login from '../components/Login'
import {sessionLogin, forgottenPassword, changePassword} from "../actions/session"
import {resetAlerts} from "../actions"

const loadData = props => {
};

class LoginPage extends Component {

	// constructor(props) {
	// 	super(props)
	// }

	componentDidMount() {
		loadData(this.props);
	}

	componentWillUnmount() {
	}

	render() {
		const {sessionLogin, forgottenPassword, changePassword, session} = this.props;
		return (
			<div>
				<Login
					onLogin={sessionLogin}
					onChangePassword={changePassword}
					onForgottenPassword={forgottenPassword}
					session={session} token={"aaa"}
				/>
			</div>
		)
	}
}

LoginPage.propTypes = {
	sessionLogin: PropTypes.func.isRequired,
	forgottenPassword: PropTypes.func.isRequired,
	changePassword: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	alerts: PropTypes.object.isRequired,
	resetAlerts: PropTypes.func.isRequired,
	// Injected by React Router
	children: PropTypes.node
};

const mapStateToProps = (state, ownProps) => ({
	alerts: state.alerts,
	session: state.session,
});

export default connect(mapStateToProps, {
	sessionLogin,
	forgottenPassword,
	changePassword,
	resetAlerts
})(LoginPage)
